import React, { ReactElement, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ContactDetails } from "../../models/ContactDetails";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setContactDetails } from '../../store/slices/contactDetailsSlice';
import { setLoading } from '../../store/slices/loaderSlice';
import { setDisplay } from '../../store/slices/navItems';
import { defaultCall, Call } from "../../models/Call";
import { setError } from '../../store/slices/errorSlice';
import NoteBox from '../shared/NoteBox';
import TaskBox from '../shared/TaskBox';
import TicketBox from '../shared/TicketBox';
import CallService from "../../services/Call.Dataservice";
import { formatToUtcDate } from '../../utils/dateFormat';

interface Props {
    contactDetails: ContactDetails;
    showBackLink: boolean;
}

const DisplayContactInfos: React.FunctionComponent<Props> = ({contactDetails, showBackLink}: Props) => {
    const dispatch = useAppDispatch();
    const credentials = useAppSelector((rootState) => rootState.credentials);
    const contactDetailsState = useAppSelector((rootState) => rootState.contactDetails);
    const navItems = useAppSelector((rootState) => rootState.navItems);
    const phone = useAppSelector((rootState) => rootState.phone);

    if (contactDetails == null){
        contactDetails = contactDetailsState;
    }
    const hubSpotLink = `https://app.hubspot.com/contacts/${contactDetails.portalId}/contact/${contactDetails.id}/`;
    const navigate = useNavigate();
    
    const logCall = () => {
        dispatch(setLoading(true));
        const call: Call = defaultCall;
        call.body = `Logged call with ${contactDetails.firstName} ${contactDetails.lastName} by ROGER365.io (Contact Center)`;
        call.callFromNumber = phone.number.replace("tel:", "");
        call.timeStamp = formatToUtcDate(new Date());
        CallService.save(credentials.client, credentials.password, credentials.portalId, contactDetails.id, 1, call).then((response) => {
            if(response != null){
                dispatch(setLoading(false));
            }
            dispatch(setError(""));
        }).catch((e: Error) => {
            dispatch(setError(e.message));
        });
        dispatch(setLoading(false));
    }

    useEffect(() => {
        dispatch(setDisplay(true));
        dispatch(setContactDetails(contactDetails));
        logCall();
    }, [])

    const showCurrentBox = () : ReactElement => {
        switch (navItems.currentBox) {
            case 1:
                return <NoteBox></NoteBox>
            case 2:
                return <TicketBox></TicketBox>
            case 3:
                return <TaskBox></TaskBox>
        }
        return <></>;   
    }

    return(
        <div className="container-lg">
            <div className="row">
                <div className="col-6 col-md-5 col-lg-4">
                    <div>{contactDetails.firstName} {contactDetails.lastName}</div>
                    <div>{contactDetails.companyName}</div>
                    <div>{contactDetails.streetAddress}</div>
                    <div>{contactDetails.postalCode ? contactDetails.postalCode : null}{contactDetails.postalCode ? " " : null}{contactDetails.city ? contactDetails.city : null}</div>
                    {contactDetails.email != "" && <div className='pt-2'><a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a></div>}
                </div>
                <div className="col-6 col-md-7 col-lg-8">
                {Object.entries(contactDetails.extendedProperties).map(([key, value], index) => {
                    return(
                        <div className="row" key={index}>
                            <div className="col-12">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>{key}:</td>
                                            <td>{value}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )
                })}
                </div>
            </div>
            <div className="row">
                <div className="d-flex pt-3">
                    { showBackLink ? <div><Link className="btn" role="button" onClick={() => navigate(-1)} to="">Back to contact list</Link></div> : null }
                    <div className="ms-auto"><a className="btn" role="button" href={hubSpotLink} target="_blank">Go to CRM</a></div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 pt-5 pb-5">
                    {showCurrentBox()}
                </div>
            </div>
        </div>
    );
}
export default DisplayContactInfos

